
const convertArray = (receivedArray) => {
    const formatted = receivedArray.replace("{","[").replace("}","]");
    return JSON.parse(formatted);
}

export const idempiereType = {
    parseArray: convertArray
}